import { useState } from "react";

import {
  makeGetApiCall,
  makePostApiCall,
  makePutApiCall,
} from "../../../shared/makeApiCall";
import { useToast } from "../../../contexts/ToastContext";

import ModelErrorComponent from "../../../components/modals/ModelErrorComponent";

export function UserBusinessDetailsViewModel(logout, userBusinessId) {
  const { showSuccess } = useToast();
  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });
  const [loading, setLoading] = useState(false);
  const [ userBusinessess, setUserBusinessess ] = useState({});


  const showErrorModal = (title, subtitle) => {
    setEmptyModelOpen({
      childComponent: (
        <ModelErrorComponent
          setOpen={setEmptyModelOpen}
          subtitle={subtitle}
          title={title}
        />
      ),
      open: true,
    });
  };

  const getUserBusiness = async function () {
    setLoading(true);
    
    let callResult = await makeGetApiCall(`admin/userBusinesses/${userBusinessId}`);
    if (callResult.success) {
      setUserBusinessess(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
    }
    setLoading(false);
  };

  const createUserBusiness = async function (values) {
    let callResult = await makePostApiCall(`admin/createUserBusiness`, values);

    if (callResult.success) {
      showSuccess(
        callResult.data.message || "Action completed"
      );
       window.location = "/user-businesses/" + callResult.data.data.id;
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
    }
  };

  const updateUserBusiness = async function (values) {
    let callResult = await makePutApiCall(`admin/updateUserBusiness/${userBusinessId}`, values);

    if (callResult.success) {
      showSuccess(
        callResult.data.message || "Action completed"
      );
     
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
    }
  };

  const getUserBusinessForDropdown = async function () {
    let callResult = await makeGetApiCall(`admin/getUserBusinessesForDropdown`);
    
    if (callResult.success) {
    
      setUserBusinessess(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
    }
  }


  return {
    createUserBusiness,
    updateUserBusiness,
    getUserBusiness,
    userBusinessess,
    loading,
    emptyModal,
    getUserBusinessForDropdown,
  };
}
